const userUseCase = (userRepo) => {
    const createUser = (input) => userRepo.createUser(input) // NO VALIDATIONS NEED

    const updateUser = (input) => {
        if (!input?.id) {
            throw Error('ID is required')
        }
        return userRepo.updateUser(input)
    }

    const findUser = (id) => {
        if (!id) {
            throw Error('ID is required')
        }
        return userRepo.findUser(id)
    }

    const getUser = (id) => {
        return userRepo.getUser(id)
    }

    const listUsers = (variables) => userRepo.listUsers(variables)

    const getSignedInUser = async () => {
        try {
            const token = localStorage.getItem('token')
            return await getUser(token)
        } catch (e) {
            return null
        }
    }

    return {
        createUser,
        updateUser,
        getUser,
        listUsers,
        findUser,
        getSignedInUser
    }
}

export default userUseCase
